import { render, staticRenderFns } from "./bargain_edit.vue?vue&type=template&id=521331c3&scoped=true"
import script from "./bargain_edit.vue?vue&type=script&lang=js"
export * from "./bargain_edit.vue?vue&type=script&lang=js"
import style0 from "./bargain_edit.vue?vue&type=style&index=0&id=521331c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521331c3",
  null
  
)

export default component.exports